import React from "react";
import IserbaProgressMap from "./iserba/IserbaProgressMap";

const ProgressMap = ({ quiz, handleVerifyPlayer, playerAlreadyPlayed }) => {
	if (quiz.organization_id === "1af3a66b-316d-4be0-8332-eb7bc15f4e27") {
		return (
			<>
				<IserbaProgressMap
					handleVerifyPlayer={handleVerifyPlayer}
					playerAlreadyPlayed={playerAlreadyPlayed}
				/>
			</>
		);
	}

	return <></>;
};

export default ProgressMap;
